import { InventoryActivitySearchCriteria } from "./InventoryActivitySearchCriteria";

export interface BuyerInventoryActivitySearchCriteria extends InventoryActivitySearchCriteria{
  supplierId?: string,
  supplierName?: string,
}

/** Keys that make the report search all dates while filled (see `withDateRangeBypass`). */
export const BUYER_INTERCHANGES_DATE_BYPASS_KEYS: readonly (keyof BuyerInventoryActivitySearchCriteria)[] = ['orderNumber'];